import React from 'react';
import './DisplayCurrentTotal.css';

export default function DisplayCurrentTotal({currentTotal}) {
  return (
    <div className="CurrentTotalDiv">Current Total: {currentTotal}</div>
  )
}
